export default __webpack_public_path__ + "static/media/hero-level-3-chars-mob.f3c27fc0.webp";